export const FETCH_STORES_RESOLVED = "FETCH_STORES_RESOLVED";
